import { collection, getDocs, query, where, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import type { PaymentPlanConfig, UserPaymentPlan, UserCredit } from "@/models/paymentPlan";

const COLLECTION = "payment_plan_configs";

/**
 * Fetch all active payment plan configs for a given festival year.
 */
export async function getPaymentPlanConfigs(
  festivalYear: number = 2027,
): Promise<PaymentPlanConfig[]> {
  const q = query(
    collection(db, COLLECTION),
    where("isActive", "==", true),
    where("festivalYear", "==", festivalYear),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }) as PaymentPlanConfig);
}

/**
 * Fetch a user's active payment plans.
 */
export async function getUserPaymentPlans(
  userId: string,
): Promise<UserPaymentPlan[]> {
  const snap = await getDocs(
    collection(db, `users/${userId}/paymentPlans`),
  );
  return snap.docs.map((d) => d.data() as UserPaymentPlan);
}

/**
 * Fetch a user's available credits.
 */
export async function getUserCredits(userId: string): Promise<UserCredit[]> {
  const q = query(
    collection(db, `users/${userId}/credits`),
    where("redeemed", "==", false),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }) as UserCredit);
}
